import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const reqUrl = err.config?.url || "";
    if (err.response?.status === 401 && !reqUrl.includes("/auth/session") && !window.location.pathname.startsWith("/approve")) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    const isAuthCall = reqUrl.includes("/auth/session") || reqUrl.includes("/auth/me");
    const isServerError = err.response?.status >= 500;
    const isNetworkError = !err.response;
    if ((isServerError || isNetworkError) && !isAuthCall) {
      // Cloudflare occasionally returns 5xx while the backend actually completed the
      // request (esp. during hot-reload). Show a soft, auto-dismissing toast that
      // tells the user to refresh instead of a scary red persistent banner.
      const isMutation = ["post", "put", "patch", "delete"].includes((err.config?.method || "").toLowerCase());
      const msg = isNetworkError
        ? "Momentary connection hiccup — if you just tapped a button, it likely still went through. Refresh in a moment to confirm."
        : isMutation
          ? "The server had a brief hiccup responding. Your action likely went through — refresh in a moment to confirm."
          : "Server hiccup while loading — try again shortly.";
      toast.warning(msg, {
        id: "backend-error",
        duration: 6000,
        action: { label: "Refresh", onClick: () => window.location.reload() },
      });
    }
    return Promise.reject(err);
  }
);

export const assetUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export const withRetry = async (fn, tries = 4, delayMs = 1500) => {
  let lastErr;
  for (let i = 0; i < tries; i++) {
    try {
      return await fn();
    } catch (e) {
      lastErr = e;
      if (e.response) throw e;
      await new Promise((r) => setTimeout(r, delayMs * (i + 1)));
    }
  }
  throw lastErr;
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong";
};
